import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Drawer, List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { createProjectSteps } from '../../constants/createProjectSteps';

export default function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = useParams();

  // Determine base path based on projectId
  const basePath = `/projects/${projectId}/`;

  // Find which item is selected by checking if the current pathname starts with basePath + step path
  const selectedItem = createProjectSteps.find(item =>
    location.pathname.startsWith(`${basePath}${item.path}`)
  );

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          top: '73px',
          height: `calc(100% - 73px)`,
        },
      }}
    >
            <Box>
                <List>
          {createProjectSteps.map((item) => {
            const selected = selectedItem?.id === item.id;

            return (
              <ListItem
                key={item.id}
                disablePadding // optional, removes default padding from ListItem to let ListItemButton handle it
              >
                <ListItemButton
                  selected={selected}
                  onClick={() => navigate(`${basePath}${item.path}`)}
                  sx={{
                    minHeight: 56,
                    paddingY: 2,
                    paddingX: 3,
                    marginBottom: 1,
                    borderRight: selected ? '4px solid #00707c' : '4px solid transparent',
                    cursor: 'pointer',
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    sx={{
                      '& .MuiTypography-root': {
                        fontSize: '1.1rem',
                        fontWeight: selected ? '700' : '500',
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

    </Drawer>
  );
}